import React, { useMemo } from 'react';
import './style.scss';
import useWindowSize from '../../../hooks/useWindowSize';
import CirclesBackground, {
  CirclesBackgroundProps
} from '../../general/circlesBackground';
import { BgMode } from '../index';
import clsx from 'clsx';
import SVGLandingNifty from '../../../assets/images/landing/nifty';
import SVGLandingHands from '../../../assets/images/landing/hands';
import CreamCan from '../../../assets/images/common/creamCan';

interface Props {
  mode: BgMode;
}

const MainBackground = ({ mode }: Props) => {
  const [sizeX] = useWindowSize();

  const circlesProps = useMemo<CirclesBackgroundProps>(() => {
    if (mode === 'fight') {
      return {
        top: '50vh',
        scale: 3.5,
        scaleShift: 0.8,
        enableLogo: true,
        size: sizeX >= 650 ? 'min(140px, 10vw)' : '15vw'
      };
    }
    if (sizeX > 650) {
      return {
        top: '130vh',
        scale: 18,
        scaleShift: 0.2,
        size: 'min(100px, 10vw)'
      };
    }
    return {
      top: '75vh',
      scale: 9,
      scaleShift: 0.4,
      size: '10vw'
    };
  }, [sizeX > 650, mode]);

  const creamCansAmount = useMemo(() => {
    if (sizeX <= 650) return 3;
    return 5;
  }, [sizeX <= 650]);

  if (mode === 'inactive') return null;

  return (
    <div className={clsx('main-bg', `main-bg-${mode}`)}>
      <CirclesBackground {...circlesProps} />
      <div className='main-bg-features'>
        <div className='main-bg-wording'>
          <SVGLandingNifty color='#351D6F' height={150} />
          <SVGLandingHands color='#351D6F' height={139} />
        </div>
        <div className='main-bg-cat-wrapper'>
          <img src='../../../assets/images/creamShop/cat.png' />
        </div>
        <div className='main-bg-cream-wrapper'>
          {[...Array(creamCansAmount)].map((_, index) => (
            <CreamCan key={index} />
          ))}
        </div>
        <div className='main-bg-markethands-wrapper'>
          <img src='../../../assets/images/market/bg_hands.png' />
        </div>
        <div className='main-bg-arc-wrapper'>
          <img src='../../../assets/images/pick/arc.png' />
        </div>
      </div>
    </div>
  );
};

export default MainBackground;
